// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 669) return "static/chunks/669-5012a74cdf0e04ec.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 740 ? "9dadc25a" : chunkId) + "." + {"618":"da865cb5a49cc65d","700":"1adc3214e531f092","740":"bd9f5bbbe3772077","912":"a9e971b5941b85d9"}[chunkId] + ".js";
};